import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import RenderIf from '../../../shared/render-if/components/render-if';
import { toggleBannerCodeModal } from '../actions/banners-actions';
import { getCampaigns } from '../../campaigns/actions/campaigns-actions';
import { getSites } from '../../link-creator/actions/link-creator-actions';
import constants from '../../../../common/constants';

import '../styles/banner.css';

class Banner extends Component {
  generateBannerCode = e => {
    const { httpInProgress, getCampaigns, toggleBannerCodeModal, campaigns, sites, getSites } = this.props;
    const { url, width, height } = e.currentTarget.dataset;

    if (httpInProgress) {
      return;
    }

    if (!campaigns) {
      getCampaigns();
    }

    if (!sites) {
      getSites(true);
    }

    toggleBannerCodeModal(true, constants.generate_code_types.banner, { url, width, height });
  };

  render() {
    const { t } = this.context;
    const { url, height, width, httpInProgress } = this.props;

    return (
      <div className="banner-container">
        <div className="banner-container__header">
          <p className="banner-container__header__size">
            {t('BANNERS.SIZE')}: {width}X{height}
          </p>
          <div className={`transparent-btn ${httpInProgress ? 'transparent-btn-disabled' : ''}`} data-url={url} data-width={width} data-height={height} onClick={this.generateBannerCode}>
            <RenderIf if={httpInProgress}>
              <span className="glyphicon glyphicon-repeat fast-right-spinner m-r-5" />
            </RenderIf>
            <span className="m-b-0">{t('BANNERS.GENERATE_CODE')}</span>
          </div>
        </div>

        <div className="banner-container__img-wrapper">
          <img src={url} alt="Banner" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  campaigns: state.campaignsReducer.campaigns,
  sites: state.linkCreatorReducer.sites,
  httpInProgress: state.httpInProgressReducer.httpInProgress,
});

const mapDispatchToProps = dispatch => ({
  toggleBannerCodeModal: (show, type, banner) => {
    dispatch(toggleBannerCodeModal(show, type, banner));
  },
  getCampaigns: () => {
    dispatch(getCampaigns());
  },
  getSites: (active, pageCode) => {
    dispatch(getSites(active, pageCode));
  },
});

Banner.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Banner);



// WEBPACK FOOTER //
// ./src/app/main/banners/components/banner.js